import { Box, BoxProps, keyframes } from '@chakra-ui/react';

const shimmer = keyframes`
  0% { background-position: -480px 0; }
  100% { background-position: 480px 0; }
`;

// Semantic tokens emit CSS vars (--chakra-colors-<token-with-dashes>)
const gradient =
  'linear-gradient(90deg, var(--chakra-colors-bg-canvas) 0%, var(--chakra-colors-border-default) 40%, var(--chakra-colors-bg-canvas) 80%)';

/** DS skeleton — shimmer gradient (design-guidelines.md §4). */
export const Skeleton = (props: BoxProps) => (
  <Box
    bg={gradient}
    bgSize='480px 100%'
    borderRadius='sm'
    animation={`${shimmer} 1.4s infinite linear`}
    {...props}
  />
);

export default Skeleton;
